<template>
  <container>
    <template #content>
      <div class="container" :class="{ 'p-0': $device?.mobile }">
        <div class="profile-wrapper">
          <div class="row g-2">
            <div class="col-md-3">
              <div class="profile_container">
                <card>
                  <div class="image_container" :class="{ 'flex-column': !$device?.mobile }">
                    <div class="profile_image_wrapper" :class="{ 'w-50': $device?.mobile }">
                      <div class="profile_image">
                        <img class="img-fluid" :src="user?.logo" />
                        <div class="upload_icon">
                          <label class="inner_icon">
                            <i class="fa fa-upload"></i>
                            <input @change.prevent="onSelectImage" type="file" class="d-none image_input" />
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="profile_details" :class="{ 'w-50': $device?.mobile }">
                      <span class="profile_name">Saurabh Jangra</span>
                      <span class="profile_username">@saurabhjangra</span>
                    </div>
                  </div>
                </card>
              </div>
            </div>
            <div class="col-md-9">
              <div class="profile_details_container">
                <card>
                  <div class="tab_wrapper">
                    <div class="tab_item active"><i class="fa-regular fa-address-card"></i> Profile</div>
                    <div class="tab_item">Activities</div>
                    <div class="tab_item">Bookings</div>
                    <div class="tab_item"><i class="fa fa-lock"></i> Change Password</div>
                  </div>
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
      <popover-model class="upload_image_model" :open="open_image_upload">
        <template #body>
          <vue-cropper
            v-if="open_image_upload"
            ref="profile_cropper"
            :canvas="{
              height: 150,
              width: 150
            }"
            :src="image"
            :stencil-component="$options.components.CircleStencil"
            :stencil-props="{ aspectRatio: 1 / 1, resizable: true }"
          />
          <hr class="my-2" />
          <div class="d-flex justify-content-center mt-3">
            <button @click.prevent="onCancel" class="btn btn-cancel">Cancel</button>
            <button @click.prevent="onSubmitImage" class="btn btn-submit">Submit</button>
          </div>
        </template>
      </popover-model>
    </template>
  </container>
</template>

<script>
import { CircleStencil } from "vue-advanced-cropper";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Profiles",
  title: "User Profile",
  breadcrumb: [{ name: "Manage User Profile" }],
  inheritAttrs: false,
  components: { CircleStencil },
  data() {
    return {
      open_image_upload: false,
      image: null,
      profile_image: null
    };
  },
  watch: {
    user: {
      deep: true,
      immediate: true,
      handler(value) {
        if (value?.logo) {
          this.profile_image = value?.logo;
        }
      }
    }
  },
  computed: {
    ...mapGetters({ user: "auth/user" })
  },
  methods: {
    ...mapActions({
      updateLogo: "users/updateProfileLogo"
    }),
    onCancel() {
      this.image = null;
      this.open_image_upload = false;
    },
    onSubmitImage() {
      const { canvas } = this.$refs.profile_cropper.getResult();
      this.updateLogo(canvas.toDataURL()).then((data) => {
        this.profile_image = canvas.toDataURL();
        this.$toaster.success("Logo Updated Successfully");
        this.onCancel();
      });
    },
    onSelectImage($event) {
      const _file = this.$_.head($event.currentTarget.files);
      var reader = new FileReader();
      reader.onload = (() => {
        return ({ currentTarget }) => {
          this.image = currentTarget.result;
          this.open_image_upload = true;
          document.querySelector(".image_input").value = "";
        };
      })(_file);
      reader.readAsDataURL(_file);
    }
  }
};
</script>

<style lang="scss">
.profile-wrapper {
  .profile_container {
    /* padding-top: 20px; */
    .image_container {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 14rem;
      .profile_image_wrapper {
        display: flex;
        justify-content: center;
        .profile_image {
          border: 1px solid var(--dp-c-input-border);
          height: 150px;
          width: 150px;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          overflow: hidden;
          position: relative;
          .upload_icon {
            display: none;
            .inner_icon {
              border: 1px solid #aab0b7;
              height: 40px;
              border-radius: 50%;
              width: 40px;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;
              &:hover {
                i {
                  color: var(--teal-dark);
                }
              }
            }
          }
          &:hover {
            .upload_icon {
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              background-color: var(--dp-c-profile-image-hover);
              font-size: var(--fnt-20);
              color: var(--bs-gray-500);
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
        }
      }
      .profile_details {
        display: flex;
        flex-direction: column;
        align-self: flex-start;
        margin-top: 0.75rem;
        padding: 0px 10px;
      }
    }
  }
  .profile_details_container {
    display: flex;
    height: 100%;
    .tab_wrapper {
      display: flex;
      .tab_item {
        display: flex;
        width: fit-content;
        font-size: var(--fnt-12);
        height: 25px;
        background-color: var(--bs-gray-700);
        justify-content: center;
        align-items: center;
        cursor: pointer;
        padding: 5px 10px;
        &.active {
          background-color: var(--teal-dark);
        }
        &:not(:last-child) {
          border-right: 1px solid gray;
        }
      }
    }
  }
}

.upload_image_model {
  &.popover_wrapper {
    width: 50%;
  }
}
</style>
